module.exports = __webpack_public_path__ + "static/media/game-icon-speech.0226e803.png";